var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8506 5.135C15.7551 4.9695 15.5977 4.84874 15.4131 4.79928C15.2285 4.74981 15.0319 4.7757 14.8664 4.87125L10.1807 7.57648H6.1957C5.81882 7.57648 5.45739 7.72619 5.1909 7.99268C4.92441 8.25917 4.7747 8.6206 4.7747 8.99747V18.8043C4.7747 19.1812 4.92441 19.5426 5.1909 19.8091C5.45739 20.0756 5.81883 20.2253 6.1957 20.2253H18.8045C19.1814 20.2253 19.5428 20.0756 19.8093 19.8091C20.0758 19.5426 20.2255 19.1812 20.2255 18.8043V15.6631L20.2256 15.653V12.1505L20.2255 12.1403V8.99747C20.2255 8.6206 20.0758 8.25917 19.8093 7.99268C19.5428 7.72619 19.1814 7.57648 18.8045 7.57648H17.2601L15.8506 5.135ZM18.7845 16.3735V18.279C18.7845 18.2816 18.7845 18.2842 18.7845 18.2869V18.7843H6.21571V9.01749H18.7845V9.86534C18.7845 9.86794 18.7845 9.87055 18.7845 9.87316V11.43H16.4404C15.0602 11.43 13.8811 12.5041 13.8811 13.9017C13.8811 15.2993 15.0602 16.3735 16.4404 16.3735H18.7845ZM18.7845 14.9324V12.871H16.4404C15.7892 12.871 15.3222 13.3653 15.3222 13.9017C15.3222 14.4382 15.7892 14.9324 16.4404 14.9324H18.7845ZM15.5933 7.57147L13.0761 7.56874L14.9629 6.47946L15.5933 7.57147Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d0266cc900fa8216cb670cd3038bebca.svg";
export { ForwardRef as ReactComponent };